import React, {Component} from "react"
import DraggableWindow from "../DraggableWindow"
import "./index.css"

interface Props {
    customClass: string
    onClose: () => void
    draggable: boolean
    resizable?: boolean
    sizes?: string[]
    onHelp?: () => void
}

interface State {
    visibleSize: number
    direction: number
    dragging: boolean
}

const VISIBLE_SIZE_MAX = 75
const VISIBLE_SIZE_MIN = 25
const VISIBLE_SIZE_DEFAULT = 25
const DELTA = 25

/**
 * Line reader allows user to concantrate a line in the question.
 */
export default class LineReader extends Component<Props, State> {
    mainCellRef: React.RefObject<HTMLDivElement>

    constructor(props) {
        super(props)
        this.state = {
            visibleSize: VISIBLE_SIZE_DEFAULT,
            direction: 1,
            dragging: false,
        }
        this.mainCellRef = React.createRef()
    }

    handleClick = () => {
        let {visibleSize, direction} = this.state

        visibleSize += direction*DELTA

        if (visibleSize >= VISIBLE_SIZE_MAX) {
            visibleSize = VISIBLE_SIZE_MAX
            direction *= -1
        }
        else if (visibleSize <= VISIBLE_SIZE_MIN) {
            visibleSize = VISIBLE_SIZE_MIN
            direction *= -1
        }

        this.setState({visibleSize, direction})
    }

    render() {
        let {draggable=true, customClass, sizes=["w-50", "w-100"], resizable=false, onClose} = this.props
        let {visibleSize, direction} = this.state

        if (this.mainCellRef.current) {
            this.mainCellRef.current.style.height = `${visibleSize}px`
        }

        return (
            <DraggableWindow title="" draggable={draggable} sizes={sizes} maximized={false} resizable={resizable} onClose={onClose} customClass={customClass}>
                <div className="line-reader-container">
                    <div className="line-reader-content">
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell transparent" ref={this.mainCellRef}/>
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim control-area">
                            <button className="control-btn" onClick={this.handleClick}>
                                <div className="caret-svg" style={{rotate: `${direction !== 1 ? 0: 180}deg`}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
                                        viewBox="0 0 24 24" fill="none" 
                                        stroke="currentColor" 
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="m18 15-6-6-6 6"/>
                                    </svg>
                                </div>
                            </button>
                        </div>
                        <div className="cell dim" />
                    </div>
                </div>
            </DraggableWindow>
        )
    }
}

/**
 * The line reader for ACT tests
 */
export class LineReaderACT extends LineReader {

    handleDragging = (e: MouseEvent) => {
        this.setState({dragging: true})
    }

    handleDraggingEnd = () => {
        this.setState({dragging: false})
    }

    render() {
        let {draggable=true, customClass, sizes=["w-50", "w-100"], resizable=false, onClose, onHelp} = this.props
        let {visibleSize, dragging} = this.state
        let showHelpButton = false // OT: For now we are not showing help button!

        visibleSize = 50

        if (this.mainCellRef.current) {
            this.mainCellRef.current.style.height = `${visibleSize}px`
        }

        return (
            <DraggableWindow title="Line Reader" 
                draggable={draggable}
                resizable={resizable}
                sizes={sizes} 
                maximized={false} 
                showMaximizeButton={false}
                showHelpButton={showHelpButton}
                onClose={onClose} 
                customClass={customClass}
                onDragging={this.handleDragging}
                onDraggingEnd={this.handleDraggingEnd}
                onHelp={onHelp}>

                <div className={`act-line-reader-container ${dragging ? "dragging": ""}`}>
                    <div className="act-line-reader-content">
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell transparent" ref={this.mainCellRef}/>
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim" />
                        <div className="cell dim" />
                    </div>
                </div>
            </DraggableWindow>
        )
    }
}